// Validate environment variables before starting the app
// (validation runs automatically when this module is imported)
import './validateEnv';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './sentry';
import ErrorBoundary from './components/ErrorBoundary';
import { setupGlobalErrorHandlers } from './utils/errorTracking';
import MaintenanceMode from './components/MaintenanceMode';

// Check if maintenance mode is enabled
const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
const maintenanceRecoveryTime = process.env.REACT_APP_MAINTENANCE_RECOVERY_TIME || 'Soon';

// Initialize Sentry error tracking before rendering (skip if in maintenance mode)
if (!isMaintenanceMode) {
  initSentry();
  // Set up global error handlers for unhandled rejections
  setupGlobalErrorHandlers();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isMaintenanceMode ? (
      <MaintenanceMode recoveryTime={maintenanceRecoveryTime} />
    ) : (
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
